// ─────────────────────────────────────────────────────────────────────────────
// FitSmith — Spieropbouw Schemas
// Splits: 2x=[FB-A,FB-B] | 3x=[Upper-A,FB-A,Lower-B] | 4x=[Upper-A,Lower-B,Upper-C,Lower-D]
// ─────────────────────────────────────────────────────────────────────────────

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const ex = (code, naam, sets_reps, tempo, rust, notitie) => ({
  code, naam, sets_reps, tempo, rust, superset: null, notitie,
});
const b  = (code, naam, notitie, rust = "90 sec") => ex(code, naam, "3 × 15", "2020", rust, notitie);
const gS = (code, naam, notitie, rust = "90 sec") => ex(code, naam, "3 × 10", "3010", rust, notitie);
const gL = (code, naam, notitie, rust = "60 sec") => ex(code, naam, "3 × 12", "3010", rust, notitie);
const aS = (code, naam, notitie, rust = "120 sec") => ex(code, naam, "4 × 6",  "3110", rust, notitie);
const aL = (code, naam, notitie, rust = "90 sec")  => ex(code, naam, "4 × 12", "3110", rust, notitie);

// ─── FULL BODY A — Quad · Borst · Ham · Rug · Bi · Tri ───────────────────────
const sp_fbA_beg = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    b("A1", "Squat (High Bar)",              "Voeten schouderbreedte. Knieën volgen de richting van de tenen. Zak tot minimaal parallelle dij. Rug recht.", "90 sec"),
    b("A2", "Bench Press",                   "Schouderbladen samenknijpen en in de bank drukken. Stang daalt naar onderkant borst. Voeten plat op de grond.", "90 sec"),
    b("A3", "Romanian Deadlift (Barbell)",   "Heupen schuiven naar achteren — niet omlaag. Rug recht. Stang blijft dicht langs de benen. Voel de hamstrings.", "90 sec"),
    b("A4", "Lat Pulldown (Breed Grip)",     "Licht achteroverleunen. Trek de stang richting de sleutelbeenderen. Ellebogen omlaag en naar achteren.", "90 sec"),
    b("A5", "Barbell Curl",                  "Ellebogen gefixeerd langs het lichaam. Curl omhoog tot volledige samentrekking. Langzaam terugzakken.", "60 sec"),
    b("A6", "Skull Crusher (EZ-Bar)",        "Ellebogen naar boven gericht. Laat de stang zakken richting voorhoofd. Ellebogen bewegen niet mee.", "60 sec"),
  ],
};
const sp_fbA_gev = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    gS("A1", "Squat (High Bar)",             "Voeten schouderbreedte. Controleer 3 seconden omlaag. Explosief omhoog. Knieën volgen de tenen."),
    gS("A2", "Bench Press",                  "Schouderbladen verankerd. Stang daalt 3 seconden naar de onderkant borst. Explosief omhoog."),
    gS("A3", "Romanian Deadlift (Barbell)",  "Heupen naar achteren. 3 seconden excentrisch. Rug vlak — geen afronden. Voel maximale hamstring stretch."),
    gS("A4", "Lat Pulldown (Breed Grip)",    "Licht achteroverleunen. Controleer 3 seconden omhoog. Trek ellebogen maximaal naar beneden."),
    gL("A5", "Barbell Curl",                 "Ellebogen gefixeerd. 3 seconden excentrisch zakken. Focus op de negatieve fase voor maximale hypertrofie.", "60 sec"),
    gL("A6", "Skull Crusher (EZ-Bar)",       "Ellebogen stabiel. 3 seconden zakken. Volledige extensie bovenaan. Triceps volledig samentrekken.", "60 sec"),
  ],
};
const sp_fbA_adv = {
  id: "A", naam: "Sessie A – Full Body",
  exercises: [
    aS("A1", "Squat (High Bar)",             "Maximale kracht. Verankerd schouderbladen. 3-1 pause tempo. Controleer excentrisch 3 sec."),
    aS("A2", "Bench Press",                  "Explosieve concentrische fase. 1 seconde isometrisch onderaan. Rug verankerd. Boog in de onderrug."),
    aS("A3", "Romanian Deadlift (Barbell)",  "Maximale hamstring stretch. 3-1 pause bij de knie. Rug vlak. Geen bouncing bij de vloer."),
    aS("A4", "Lat Pulldown (Breed Grip)",    "Volledige range of motion. 3 sec excentrisch. Ellebogen maximaal naar beneden en achteren."),
    aL("A5", "Barbell Curl",                 "Supinatie bovenaan. 3 sec excentrisch. Ellebogen gefixeerd — geen slingeren."),
    aL("A6", "Skull Crusher (EZ-Bar)",       "Maximale triceps stretch onderaan. 3 sec excentrisch. Ellebogen stabiel. Volledig strekken."),
  ],
};

// ─── FULL BODY B — Quad · Borst · Ham · Rug · Bi · Tri ───────────────────────
const sp_fbB_beg = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    b("A1", "Leg Press",                      "Voeten schouderbreedte op het platform. Knieën niet volledig strekken bovenaan. Controleer de excentrische fase.", "90 sec"),
    b("A2", "Incline Dumbbell Press",         "Bank 30–45°. Dumbbells starten naast de borst. Duw omhoog en iets naar elkaar. Focus op bovenborst.", "90 sec"),
    b("A3", "Leg Curl (Liggend)",             "Buikligging. Hiel trekt richting bil. Langzaam terugzakken in 2 seconden. Heupen blijven op de bank.", "90 sec"),
    b("A4", "Seated Cable Row (Smal Grip)",   "Zit rechtop. Trek naar de navel. Schouderbladen maximaal samentrekken. Rug recht houden.", "90 sec"),
    b("A5", "Hammer Curl",                    "Neutraal grip (duimen omhoog). Bovenarm beweegt niet mee. Volledig strekken onderaan.", "60 sec"),
    b("A6", "Tricep Pushdown (Touw)",         "Ellebogen naast het lichaam. Trek het touw uiteen onderaan voor maximale samentrekking.", "60 sec"),
  ],
};
const sp_fbB_gev = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    gS("A1", "Leg Press",                     "Voeten laag op het platform voor meer quadriceps focus. 3 sec excentrisch. Geen lockout bovenaan."),
    gS("A2", "Incline Dumbbell Press",        "Bank 30°. 3 sec excentrisch. Dumbbells niet helemaal sluiten bovenaan — houd spanning op de borst."),
    gS("A3", "Leg Curl (Liggend)",            "3 sec excentrisch. Volledig strekken voor elke herhaling. Heupen verankerd aan de bank."),
    gS("A4", "Seated Cable Row (Smal Grip)",  "3 sec excentrisch. Schouderbladen maximaal samentrekken. Borst licht vooruit bij het trekken."),
    gL("A5", "Hammer Curl",                   "3 sec excentrisch. Volledige range. Dumbbell draait niet — neutraal grip door de hele beweging.", "60 sec"),
    gL("A6", "Tricep Pushdown (Touw)",        "Touw uiteentrekken onderaan. 3 sec excentrisch. Ellebogen stabiel naast het lichaam.", "60 sec"),
  ],
};
const sp_fbB_adv = {
  id: "B", naam: "Sessie B – Full Body",
  exercises: [
    aS("A1", "Leg Press",                     "Maximale kracht. 3 sec excentrisch. Volledige range. Voeten laag voor maximale quad activatie."),
    aS("A2", "Incline Dumbbell Press",        "Diepe stretch onderaan. 1 sec pause. Explosief omhoog. 3 sec excentrisch."),
    aS("A3", "Leg Curl (Liggend)",            "Maximale hamstring samentrekking bovenaan. 3 sec excentrisch. Volledige extensie per rep."),
    aS("A4", "Seated Cable Row (Smal Grip)",  "Maximale rug samentrekking. 3 sec excentrisch. Schouderbladen volledig samentrekken."),
    aL("A5", "Hammer Curl",                   "3 sec excentrisch. Supineer niet — houd neutraal grip. Maximale peak contractie bovenaan."),
    aL("A6", "Tricep Pushdown (Touw)",        "Maximale extensie. Touw uiteentrekken onderaan. 3 sec excentrisch. Ellebogen gefixeerd."),
  ],
};

// ─── UPPER A — Borst · Rug · Borst · Rug · Borst · Rug ──────────────────────
const sp_upperA_beg = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    b("A1", "Bench Press",                   "Schouderbladen samenknijpen. Stang naar onderkant borst. Explosief omhoog, gecontroleerd omlaag.", "90 sec"),
    b("A2", "Barbell Row – Overhand",        "Romp 45° voorover. Trek de stang naar de onderkant van de borst. Ellebogen naar buiten. Knieën licht gebogen.", "90 sec"),
    b("A3", "Incline Dumbbell Press",        "Bank 30–45°. Focus op de bovenborst. Dumbbells boven de borst starten. Gecontroleerd neerzakken.", "90 sec"),
    b("A4", "Lat Pulldown (Breed Grip)",     "Licht achteroverleunen. Trek naar de sleutelbeenderen. Ellebogen omlaag. Focus volledig op de rug.", "90 sec"),
    b("A5", "Cable Fly (High to Low)",       "Kabels hoog instellen. Beweging van boven naar beneden en naar elkaar. Knijp de borst samen onderaan.", "60 sec"),
    b("A6", "Seated Cable Row (Smal Grip)",  "Rechtop zitten. Trek naar de navel. Schouderbladen maximaal naar elkaar. Rug recht.", "60 sec"),
  ],
};
const sp_upperA_gev = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    gS("A1", "Bench Press",                  "3 sec excentrisch. Explosief omhoog. Schouderbladen verankerd. Stang raakt de borst bij elke rep."),
    gS("A2", "Barbell Row – Overhand",       "3 sec excentrisch laten zakken. Ellebogen hoog. Trek naar de buik. Rug vlak op elke rep."),
    gS("A3", "Incline Dumbbell Press",       "3 sec excentrisch. Geen volledige sluiting bovenaan. Houd spanning op de bovenborst."),
    gS("A4", "Lat Pulldown (Breed Grip)",    "3 sec excentrisch omhoog. Maximale lat stretch bovenaan. Trek ellebogen maximaal omlaag."),
    gL("A5", "Cable Fly (High to Low)",      "Lichte contantie in de ellebogen. Focus op de borstspier. 3 sec excentrisch. Geen slingeren.", "60 sec"),
    gL("A6", "Seated Cable Row (Smal Grip)", "Maximale rug contractie. 3 sec excentrisch. Borst licht vooruit bij het trekken.", "60 sec"),
  ],
};
const sp_upperA_adv = {
  id: "A", naam: "Sessie A – Upper Body",
  exercises: [
    aS("A1", "Bench Press",                  "1 sec pause onderaan. Explosief omhoog. 3 sec excentrisch. Maximale kracht."),
    aS("A2", "Barbell Row – Overhand",       "3 sec excentrisch laten zakken. Trek explosief omhoog. Maximale rug samentrekking."),
    aS("A3", "Incline Dumbbell Press",       "Diepe stretch. 1 sec pause onderaan. 3 sec excentrisch. Explosieve concentrische fase."),
    aS("A4", "Lat Pulldown (Breed Grip)",    "Volledige lat stretch. 3 sec excentrisch omhoog. Maximale rug samentrekking bij het trekken."),
    aL("A5", "Cable Fly (High to Low)",      "Maximale borst stretch. 3 sec excentrisch. Lichte buiging ellebogen. Volledig naar elkaar brengen."),
    aL("A6", "Seated Cable Row (Smal Grip)", "Maximale rug samentrekking. 3 sec excentrisch. Schouderbladen volledig naar elkaar."),
  ],
};

// ─── UPPER C — Borst · Rug · Borst · Rug · Borst · Rug ──────────────────────
const sp_upperC_beg = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    b("A1", "Dumbbell Bench Press",          "Dumbbells parallel of licht gedraaid. Dieper bereik dan barbell. Duw omhoog en breng de dumbbells dicht bij elkaar.", "90 sec"),
    b("A2", "Dumbbell Row (Eenhandig)",      "Knie op de bank. Trek de dumbbell langs het lichaam omhoog. Elleboog gaat hoog. Licht meeroterende beweging.", "90 sec"),
    b("A3", "Machine Chest Press",           "Stoel afstellen zodat handgrepen op borsthoogte. Duw explosief naar voren. Gecontroleerd terug.", "90 sec"),
    b("A4", "Lat Pulldown (Reverse Grip)",   "Onderhands grip, smaller dan schouderbreedte. Trek naar de borst. Meer biceps betrokken. Licht achteroverleunen.", "90 sec"),
    b("A5", "Pec Deck (Machine Fly)",        "Ellebogen op de pads. Borst vooruit. Armen samenknijpen en langzaam terug. Focus op de borst stretch.", "60 sec"),
    b("A6", "Rear Delt Fly (Dumbbell)",      "Voorovergebogen. Armen breed opzijwaarts opheffen. Lichte gewichten. Langzame beweging. Focus achterschouder.", "60 sec"),
  ],
};
const sp_upperC_gev = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    gS("A1", "Dumbbell Bench Press",         "Diep neerzakken. 3 sec excentrisch. Dumbbells bijna aanraken bovenaan. Schouders verankerd."),
    gS("A2", "Dumbbell Row (Eenhandig)",     "3 sec excentrisch laten zakken. Elleboog maximaal omhoog bij het trekken. Romp stabiel."),
    gS("A3", "Machine Chest Press",          "3 sec excentrisch. Explosief naar voren. Volledige range of motion. Borst vooruit."),
    gS("A4", "Lat Pulldown (Reverse Grip)",  "3 sec excentrisch. Trek naar de sleutelbeenderen. Licht achteroverleunen. Focus op de rug."),
    gL("A5", "Pec Deck (Machine Fly)",       "Maximale borst stretch. 3 sec excentrisch. Knijp de borst samen bij sluiting. Focus op isolatie.", "60 sec"),
    gL("A6", "Rear Delt Fly (Dumbbell)",     "Licht gewicht. Breed optillen tot schouderhoogte. 3 sec excentrisch. Focus op achterschouder.", "60 sec"),
  ],
};
const sp_upperC_adv = {
  id: "C", naam: "Sessie C – Upper Body",
  exercises: [
    aS("A1", "Dumbbell Bench Press",         "Maximale stretch onderaan. 1 sec pause. 3 sec excentrisch. Explosief omhoog."),
    aS("A2", "Dumbbell Row (Eenhandig)",     "Maximale rug samentrekking. 3 sec excentrisch laten zakken. Elleboog zo hoog mogelijk."),
    aS("A3", "Machine Chest Press",          "1 sec pause vooraan. 3 sec excentrisch. Explosieve kracht. Maximale borst samentrekking."),
    aS("A4", "Lat Pulldown (Reverse Grip)",  "Volledige range. 3 sec excentrisch. Maximale lat stretch. Trek explosief."),
    aL("A5", "Pec Deck (Machine Fly)",       "Maximale stretch. 3 sec excentrisch. Borst volledig samentrekken bij sluiting. Lichte elleboogbuiging."),
    aL("A6", "Rear Delt Fly (Dumbbell)",     "Licht gewicht. Gecontroleerde beweging. 3 sec excentrisch. Achterschouder volledig samentrekken."),
  ],
};

// ─── LOWER B — Quad · Ham · Quad · Ham · Kuit · Core ─────────────────────────
const sp_lowerB_beg = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    b("A1", "Squat (High Bar)",              "Voeten schouderbreedte. Knieën volgen de richting van de tenen. Rug recht. Zak tot parallel.", "90 sec"),
    b("A2", "Romanian Deadlift (Barbell)",   "Heupen naar achteren. Rug vlak. Stang langs de benen. Voel de hamstrings rekken.", "90 sec"),
    b("A3", "Leg Press",                     "Voeten schouderbreedte. Knieën niet volledig strekken bovenaan. Gecontroleerd zakken.", "90 sec"),
    b("A4", "Leg Curl (Liggend)",            "Hiel trekt richting bil. Langzaam terugzakken. Heupen blijven op de bank. Volledige extensie.", "90 sec"),
    b("A5", "Standing Calf Raise (Machine)", "Volledig strekken bovenaan. Volledig zakken onderaan. Langzame gecontroleerde beweging.", "60 sec"),
    b("A6", "Crunch",                        "Handen naast het hoofd. Schouders van de grond. Buikspieren volledig samentrekken. Langzaam terug.", "60 sec"),
  ],
};
const sp_lowerB_gev = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    gS("A1", "Squat (High Bar)",             "3 sec excentrisch. Explosief omhoog. Knieën volgen de tenen. Rug recht. Zak tot onder parallel."),
    gS("A2", "Romanian Deadlift (Barbell)",  "3 sec excentrisch. Heupen maximaal naar achteren. Stang langs de scheenbenen. Hamstring stretch."),
    gS("A3", "Leg Press",                    "3 sec excentrisch. Voeten laag op het platform voor maximale quadriceps focus. Geen lockout."),
    gS("A4", "Leg Curl (Liggend)",           "3 sec excentrisch. Maximale hiel-bil afstand. Heupen verankerd aan de bank."),
    gL("A5", "Standing Calf Raise (Machine)","3 sec excentrisch. 1 sec bovenaan. Volledig zakken voor maximale stretch. Focus op gastrocnemius.", "60 sec"),
    gL("A6", "Crunch",                       "3 sec excentrisch. Maximale buik samentrekking bovenaan. Handen naast het hoofd, niet trekken.", "60 sec"),
  ],
};
const sp_lowerB_adv = {
  id: "B", naam: "Sessie B – Lower Body",
  exercises: [
    aS("A1", "Squat (High Bar)",             "Maximale kracht. 3 sec excentrisch. Explosief omhoog. 1 sec pause onderaan."),
    aS("A2", "Romanian Deadlift (Barbell)",  "Maximale hamstring stretch. 3-1 pause. Rug vlak. Stang langs de benen bij elke rep."),
    aS("A3", "Leg Press",                    "Maximale kracht. 3 sec excentrisch. Voeten laag. Volledige range. Geen lockout."),
    aS("A4", "Leg Curl (Liggend)",           "Maximale hamstring samentrekking. 3 sec excentrisch. 1 sec pause bovenaan."),
    aL("A5", "Standing Calf Raise (Machine)","Volledig zakken — maximale Achilles stretch. 1 sec bovenaan knijpen. 3 sec excentrisch."),
    aL("A6", "Crunch",                       "3 sec excentrisch. Gewicht op de borst voor extra weerstand. Maximale buik contractie."),
  ],
};

// ─── LOWER D — Quad · Ham · Quad · Ham · Kuit · Core ─────────────────────────
const sp_lowerD_beg = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    b("A1", "Bulgarian Split Squat",         "Achterste voet op de bank. Zak recht omlaag. Voorste knie volgt de teen. Romp rechtop.", "90 sec"),
    b("A2", "Romanian Deadlift (Dumbbell)",  "Dumbbells langs de benen naar beneden. Heupen naar achteren. Rug recht. Voel de hamstrings.", "90 sec"),
    b("A3", "Hack Squat (Machine)",          "Voeten laag op het platform voor meer quadriceps focus. Controleer de excentrische fase.", "90 sec"),
    b("A4", "Leg Curl (Zittend)",            "Rug in de stoel. Hiel trekt omlaag. Volledig strekken voor het begin van elke herhaling.", "90 sec"),
    b("A5", "Seated Calf Raise (Machine)",   "Gewicht op de bovenkant van de knieën. Volledig strekken en zakken. Langzame gecontroleerde beweging.", "60 sec"),
    b("A6", "Cable Crunch",                  "Knieën op de grond. Touw bij het hoofd. Buig de romp naar beneden. Buikspieren samentrekken.", "60 sec"),
  ],
};
const sp_lowerD_gev = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    gS("A1", "Bulgarian Split Squat",        "3 sec excentrisch. Knie raakt bijna de grond. Romp rechtop. Zak zo diep mogelijk per been."),
    gS("A2", "Romanian Deadlift (Dumbbell)", "3 sec excentrisch. Dumbbells langs de benen. Maximale hamstring stretch."),
    gS("A3", "Hack Squat (Machine)",         "3 sec excentrisch. Voeten laag. Volledige range of motion. Geen lockout bovenaan."),
    gS("A4", "Leg Curl (Zittend)",           "3 sec excentrisch. Volledig strekken per rep. Hiel maximaal naar het zadel trekken."),
    gL("A5", "Seated Calf Raise (Machine)",  "3 sec excentrisch. Maximale Achilles stretch onderaan. 1 sec squeeze bovenaan.", "60 sec"),
    gL("A6", "Cable Crunch",                 "3 sec excentrisch. Voel de buikspieren maximaal rekken. Trek de ellebogen naar de knieën.", "60 sec"),
  ],
};
const sp_lowerD_adv = {
  id: "D", naam: "Sessie D – Lower Body",
  exercises: [
    aS("A1", "Bulgarian Split Squat",        "Maximale diepte. 3 sec excentrisch. 1 sec pause onderaan. Explosief omhoog. Per been apart tellen."),
    aS("A2", "Romanian Deadlift (Dumbbell)", "Maximale hamstring stretch. 3-1 pause bij de knie. Rug vlak. Dumbbells dicht langs de benen."),
    aS("A3", "Hack Squat (Machine)",         "Maximale kracht. 3 sec excentrisch. Voeten laag. 1 sec pause onderaan."),
    aS("A4", "Leg Curl (Zittend)",           "Maximale samentrekking. 3 sec excentrisch. 1 sec pause bovenaan."),
    aL("A5", "Seated Calf Raise (Machine)",  "3 sec excentrisch. Volledig zakken. 2 sec squeeze bovenaan. Soleus focus."),
    aL("A6", "Cable Crunch",                 "Extra gewicht op de kabel. 3 sec excentrisch. Maximale buik contractie. Rug afronden bij sluiting."),
  ],
};

// ─── EXPORT ───────────────────────────────────────────────────────────────────
export const SPIEROPBOUW_SCHEMAS = {
  "spieropbouw-beginner-2x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Beginner", frequentie: "2x per week",
      schema_naam: "Spieropbouw Beginner – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Twee volledige lichaamssessies per week. Ideaal voor beginners om het hele lichaam te trainen met voldoende herstel tussen de sessies.",
    },
    sessions: [sp_fbA_beg, sp_fbB_beg],
  },
  "spieropbouw-beginner-3x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Beginner", frequentie: "3x per week",
      schema_naam: "Spieropbouw Beginner – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower split. Optimale stimulatie van alle spiergroepen met voldoende herstel. Techniek staat centraal.",
    },
    sessions: [sp_upperA_beg, sp_fbA_beg, sp_lowerB_beg],
  },
  "spieropbouw-beginner-4x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Beginner", frequentie: "4x per week",
      schema_naam: "Spieropbouw Beginner – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Upper-Lower split twee keer per week. Hogere frequentie per spiergroep voor snellere progressie. Voldoende eiwitten en slaap essentieel.",
    },
    sessions: [sp_upperA_beg, sp_lowerB_beg, sp_upperC_beg, sp_lowerD_beg],
  },

  "spieropbouw-gevorderd-2x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Gevorderd", frequentie: "2x per week",
      schema_naam: "Spieropbouw Gevorderd – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Twee volledige lichaamssessies met gevorderd volume en intensiteit. Hogere belasting vereist prioriteit aan herstel.",
    },
    sessions: [sp_fbA_gev, sp_fbB_gev],
  },
  "spieropbouw-gevorderd-3x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Gevorderd", frequentie: "3x per week",
      schema_naam: "Spieropbouw Gevorderd – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower split. Elke sessie met gevorderd volume. Focus op progressieve overbelasting en excentrische controle.",
    },
    sessions: [sp_upperA_gev, sp_fbA_gev, sp_lowerB_gev],
  },
  "spieropbouw-gevorderd-4x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Gevorderd", frequentie: "4x per week",
      schema_naam: "Spieropbouw Gevorderd – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Maximale spiergroepfrequentie voor gevorderden. Herstel prioriteren: 8 uur slaap, voldoende calorieën en 2g eiwit per kg.",
    },
    sessions: [sp_upperA_gev, sp_lowerB_gev, sp_upperC_gev, sp_lowerD_gev],
  },

  "spieropbouw-advanced-2x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Advanced", frequentie: "2x per week",
      schema_naam: "Spieropbouw Advanced – 2x per week",
      weekstructuur: "Maandag: Sessie A – Full Body  |  Donderdag: Sessie B – Full Body",
      notitie: "Hoog volume per sessie met advanced intensiteit. Ideaal voor drukke weken. 4×6 vraagt maximale concentratie en kracht.",
    },
    sessions: [sp_fbA_adv, sp_fbB_adv],
  },
  "spieropbouw-advanced-3x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Advanced", frequentie: "3x per week",
      schema_naam: "Spieropbouw Advanced – 3x per week",
      weekstructuur: "Maandag: Sessie A – Upper Body  |  Woensdag: Sessie B – Full Body  |  Vrijdag: Sessie C – Lower Body",
      notitie: "Upper-Full-Lower split met advanced intensiteit. 4×6 op de hoofdoefeningen. Volledige concentratie op techniek bij zwaar gewicht.",
    },
    sessions: [sp_upperA_adv, sp_fbA_adv, sp_lowerB_adv],
  },
  "spieropbouw-advanced-4x": {
    meta: {
      doel: "Spieropbouw", sub_doel: "spiermassa & kracht",
      niveau: "Advanced", frequentie: "4x per week",
      schema_naam: "Spieropbouw Advanced – 4x per week",
      weekstructuur: "Maandag: Sessie A – Upper  |  Dinsdag: Sessie B – Lower  |  Donderdag: Sessie C – Upper  |  Vrijdag: Sessie D – Lower",
      notitie: "Maximale intensiteit en volume. 4×6 op alle hoofdoefeningen. 2g eiwit per kg, 8–9 uur slaap en deload elke 4–6 weken essentieel.",
    },
    sessions: [sp_upperA_adv, sp_lowerB_adv, sp_upperC_adv, sp_lowerD_adv],
  },
};
